var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGrossprofit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "38-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "037512-Analytics---monthly-sales-2",
    transform: "translate(-896.000000, -957.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy",
    transform: "translate(857.000000, 574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(30.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy-3",
    transform: "translate(0.000000, 231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_grossprofit",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    fill: "#EFF6F2",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/sidebar/Bookkeeping-Finance",
    transform: "translate(9.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16.5454545 L2,16.5454545 L2,18 L18,18 L18,16.5454545 Z M18,13.5454545 L2,13.5454545 L2,15 L18,15 L18,13.5454545 Z M5.63636364,6.36363636 C5.234702,6.36363636 4.90909091,6.68924745 4.90909091,7.09090909 C4.90909091,7.49257073 5.234702,7.81818182 5.63636364,7.81818182 C6.03802527,7.81818182 6.36363636,7.49257073 6.36363636,7.09090909 C6.36363636,6.68924745 6.03802527,6.36363636 5.63636364,6.36363636 Z M15.8181818,2 L4.18181818,2 C2.97683327,2 2,2.97683327 2,4.18181818 L2,10 C2,11.2049849 2.97683327,12.1818182 4.18181818,12.1818182 L15.8181818,12.1818182 C17.0231667,12.1818182 18,11.2049849 18,10 L18,4.18181818 C18,2.97683327 17.0231667,2 15.8181818,2 Z M16.5454545,10 C16.5454545,10.4016616 16.2198435,10.7272727 15.8181818,10.7272727 L4.18181818,10.7272727 C3.78015655,10.7272727 3.45454545,10.4016616 3.45454545,10 L3.45454545,4.18181818 C3.45454545,3.78015655 3.78015655,3.45454545 4.18181818,3.45454545 L15.8181818,3.45454545 C16.2198435,3.45454545 16.5454545,3.78015655 16.5454545,4.18181818 L16.5454545,10 Z M10,4.90909091 C8.79501509,4.90909091 7.81818182,5.88592418 7.81818182,7.09090909 C7.81818182,8.295894 8.79501509,9.27272727 10,9.27272727 C11.2049849,9.27272727 12.1818182,8.295894 12.1818182,7.09090909 C12.1818182,5.88592418 11.2049849,4.90909091 10,4.90909091 Z M10,7.81818182 C9.59833836,7.81818182 9.27272727,7.49257073 9.27272727,7.09090909 C9.27272727,6.68924745 9.59833836,6.36363636 10,6.36363636 C10.4016616,6.36363636 10.7272727,6.68924745 10.7272727,7.09090909 C10.7272727,7.49257073 10.4016616,7.81818182 10,7.81818182 Z M14.3636364,6.36363636 C13.9619747,6.36363636 13.6363636,6.68924745 13.6363636,7.09090909 C13.6363636,7.49257073 13.9619747,7.81818182 14.3636364,7.81818182 C14.765298,7.81818182 15.0909091,7.49257073 15.0909091,7.09090909 C15.0909091,6.68924745 14.765298,6.36363636 14.3636364,6.36363636 Z",
    id: "Shape",
    fill: "#2F665C",
    fillRule: "nonzero"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGrossprofit);
export default __webpack_public_path__ + "static/media/ic-grossprofit.f4cbd72d6c3a55c0420cd85f3ff2e716.svg";
export { ForwardRef as ReactComponent };